import { environment } from '@/app/environments/environment';

export const storagePrefix = environment.environmentStoragePrefix + 'cloudOTDR';
